import { gql } from "@apollo/client";

const ADD_DEDUCTION_ITEM = gql`
  mutation AddDeductionItem($params: AddManualDeductionItemParams!) {
    createDeductionItem(params: $params) {
      data {
        newlyInsertedDeductionItems
        skippedDeductionItems
      }
      error {
        errorColumn
        errorDetails
        processId
      }
    }
  }
`;

export default ADD_DEDUCTION_ITEM;
